import { TableCellCaseAppealIcon } from "../../../../data-model/tableCells";
import { PharmaStpFileModel } from "../../../../data-model/nycbsPharmaOrder";

/**
 * Builds the Case Appeal icon cell value for an Astera Oncology External row.
 * Green check when `appeal_status` is present; ellipsis badge when it is null.
 *
 * @param item - Raw order row from the API
 * @return TableCellCaseAppealIcon: Icon variant for the Case Appeal column
 */
export const getAsteraCaseAppealIconValue = (
  item: PharmaStpFileModel,
): TableCellCaseAppealIcon => {
  return {
    variant: item.appeal_status != null ? "approved" : "denied",
  };
};
